var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80078 5.84155C6.80078 2.96128 9.12005 0.600586 12.0008 0.600586C14.8815 0.600586 17.2008 2.96128 17.2008 5.84155V8.80078H18.489C20.0354 8.80078 21.289 10.0544 21.289 11.6008L21.2891 19.5858C21.2891 20.6134 20.7102 21.6344 19.6424 22.032C18.2556 22.5483 15.6212 23.3008 12.0447 23.3008C8.46755 23.3008 5.82807 22.548 4.43859 22.032C3.36957 21.6349 2.78908 20.6131 2.78908 19.584L2.78906 11.6008C2.78906 10.0544 4.04266 8.80078 5.58906 8.80078H6.80078V5.84155ZM14.8008 5.84155V8.80078H9.20078V5.84155C9.20078 4.26365 10.4685 3.00059 12.0008 3.00059C13.533 3.00059 14.8008 4.26365 14.8008 5.84155ZM10.0996 14.8009C10.0996 13.7515 10.9503 12.9009 11.9996 12.9009C13.049 12.9009 13.8996 13.7515 13.8996 14.8009C13.8996 15.4717 13.5519 16.0614 13.0269 16.3995L13.0266 17.8011C13.0265 18.3679 12.5669 18.8274 12.0001 18.8273C11.4333 18.8271 10.9738 18.3676 10.974 17.8007L10.9742 16.4007C10.4481 16.0628 10.0996 15.4726 10.0996 14.8009Z",
    fill: "#1A1C20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.0462481a0e25eef415f6f3c58469768d.svg";
export { ForwardRef as ReactComponent };